import React, { forwardRef } from 'react';
import { MessageType, Status } from '../graphql/graphql';
import { MetadataMessage } from './Message/MetadataMessage';
import { ChatBoxMessage } from '../design_system/ChatBoxMessage';
import { isStatusEvent, StatusMessage } from './Message/StatusMessage';
import { ActionMessage, isActionEvent } from './Message/ActionMessage';
import { isMessageEvent } from '../design_system/ChatBoxMessage';
import { MessagingStateMessage, } from './Message/MessagingStateMessage';
import { useTranslation } from 'react-i18next';
import { O } from '../lib/EffectExports';
import { ChatboxMessageContainer } from '../design_system/ChatboxMessageContainer';
import { getLineOfBusinessName } from '../i18n/translations';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
export const ChatBox = forwardRef(({ events, advisorTypingEvent, showWelcome = false, onOptionClick, onCommandClick, onSnapToLatestChange, onAttachmentClick, onCloseToTop, isLastMessageCloseEvent = false, }, ref) => {
    const { t } = useTranslation();
    const { lineOfBusiness } = useLineOfBusiness();
    if (showWelcome) {
        return (React.createElement(MetadataMessage, { loading: true, text: t('WAITING_WELCOME_MESSAGE_TEXT', {
                line_of_business_name: getLineOfBusinessName(lineOfBusiness),
            }) }));
    }
    return (React.createElement(ChatboxMessageContainer, { ref: ref, onCloseToTop: onCloseToTop, onSnapToLatestChange: onSnapToLatestChange },
        events.map((event, index) => {
            if (isStatusEvent(event)) {
                const isFirstOpenEvent = event.supportCaseStatusEvent.status === Status.Open &&
                    index === 0;
                return (React.createElement(StatusMessage, { key: event.id, event: event, isFirstOpenEvent: isFirstOpenEvent }));
            }
            if (isActionEvent(event)) {
                return React.createElement(ActionMessage, { key: event.id, event: event });
            }
            if (isMessageEvent(event)) {
                const isNotLastOption = (event.messageEvent.messageType === MessageType.Question ||
                    event.messageEvent.messageType === MessageType.Command) &&
                    index !== events.length - 1;
                return (React.createElement(ChatBoxMessage, { isNotLastOption: isNotLastOption, isLastMessageCloseEvent: isLastMessageCloseEvent, key: event.id, event: event, onOptionClick: onOptionClick, onAttachmentClick: onAttachmentClick, onCommandClick: onCommandClick }));
            }
            return null;
        }),
        O.match(advisorTypingEvent, {
            onNone: () => null,
            onSome: event => React.createElement(MessagingStateMessage, { event: event }),
        })));
});
//# sourceMappingURL=ChatBox.js.map